export default "__VITE_PUBLIC_ASSET__7b84b9ea__"